import { Formik, FormikHelpers } from "formik";
import { useAtom } from "jotai";
import { atomIsModalOpen } from "../../atoms";
import {
  IAvisEditableListAddEditConfig,
  IEditableListRowState,
} from "../../types";
import { AvisEditableListModalForm } from "./AvisEditableListModalForm";

interface IAvisEditableListModalProps<P extends IEditableListRowState> {
  initData: P;
  editMode: boolean;
  disabled?: boolean;
  customAddEditConfig?: IAvisEditableListAddEditConfig<P>;
  onConfirm: (values: P) => void;
}
export function AvisEditableListModal<P extends IEditableListRowState>(
  props: Readonly<IAvisEditableListModalProps<P>>,
) {
  const { initData, customAddEditConfig, onConfirm } = props;
  const [isModalOpen] = useAtom(atomIsModalOpen);

  const handleSubmit = async (values: P, formikHelpers: FormikHelpers<P>) => {
    const errors = await formikHelpers.validateForm();
    if (Object.keys(errors).length > 0) return;
    onConfirm(values);
    formikHelpers.resetForm();
  };

  if (
    !customAddEditConfig?.renderForm ||
    !customAddEditConfig?.validationSchema ||
    !isModalOpen
  ) {
    return null;
  }

  return (
    <Formik<P>
      initialValues={initData}
      onSubmit={handleSubmit}
      enableReinitialize
      validationSchema={customAddEditConfig.validationSchema}
      validateOnBlur={false}
      validateOnChange={false}
    >
      {(formikProps) => (
        <AvisEditableListModalForm<P>
          {...props}
          formikProps={formikProps}
          title={customAddEditConfig.title}
          renderInnerForm={customAddEditConfig.renderForm}
        />
      )}
    </Formik>
  );
}
